<template>
  <validated-form-modal
    ref="setupModal"
    :title="title"
    :submit="savePin"
    :ok-only="mandatory"
    :no-close="mandatory"
    cancel-title="button.later"
  >
    <div class="flex flex-col gap-4">
      <p class="text-md">{{ $t('deviceSessions.setupHelp') }}</p>
      <pin-input
        check-strength
        :label="$t('deviceSessions.pin')"
        :api-errors="validationErrors"
        :help-text="$t('deviceSessions.pinHint')"
      ></pin-input>
    </div>
  </validated-form-modal>
</template>

<script setup lang="ts">
import PinInput from '@/components/auth/PinInput.vue';
import ValidatedFormModal from '@/components/shared/modals/ValidatedFormModal.vue';
import { useUsersStore } from '@/store/users-store';
import { computed, onMounted, ref, watch } from 'vue';

const props = withDefaults(defineProps<{ prompt?: boolean }>(), {
  prompt: false,
});

const usersStore = useUsersStore();
const setupModal = ref<InstanceType<typeof ValidatedFormModal>>();
const asked = ref(false);

const validationErrors = computed(() => usersStore.user.validationErrors);
const title = computed(() => usersStore.pinActionLabel);
const mandatory = computed(() => props.prompt && usersStore.mustDefinePin);

function open() {
  setupModal.value?.openModal();
}

function promptOnce() {
  if (!props.prompt || !usersStore.mustDefinePin || asked.value) {
    return;
  }
  asked.value = true;
  setupModal.value?.openModal();
}

onMounted(promptOnce);
watch(() => usersStore.mustDefinePin, promptOnce);

defineExpose({ open });

async function savePin(values: Record<string, unknown>): Promise<boolean> {
  return usersStore.setPin(values.pin as string);
}
</script>
